// removed by extract-text-webpack-plugin
module.exports = {"keyIcon":"DesktopRealTalk-styles__keyIcon--Ybivl","fullAccessButton":"DesktopRealTalk-styles__fullAccessButton--U7XdL","fullAccessLabelText":"DesktopRealTalk-styles__fullAccessLabelText--1-Wmp"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Footer/DesktopFooter/DesktopRealTalk.styles.css
// module id = iVyW
// module chunks = 0